export function mapErrors(errors) {
    const result = {};
    for (const error of errors) {
        result[error.row] = error.message;
    }
    return result;
}
